import { render, staticRenderFns } from "./250320-GetNotesForTickets.vue?vue&type=template&id=5e778b50&scoped=true"
import script from "./250320-GetNotesForTickets.vue?vue&type=script&lang=js"
export * from "./250320-GetNotesForTickets.vue?vue&type=script&lang=js"
import style0 from "./250320-GetNotesForTickets.vue?vue&type=style&index=0&id=5e778b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e778b50",
  null
  
)

export default component.exports